export default class TrackingEvents {
  static homepageViewed = () => 'Homepage Viewed';
  static categorySelected = () => 'Category Selected';
  static continueShopping = () => 'Continue Shopping Clicked';
  static designerSelected = () => 'Designer Selected';
  static filterApplied = () => 'Filter Applied';
  static filterOpen = () => 'Filter Opened';
  static filterClose = () => 'Filter Closed';
  static filterRemoved = () => 'Filter Removed';
  static departmentSelected = () => 'Department Selected';
  static heroSelected = () => 'Hero Selected';
  static homeBoxSelected = () => 'Homepage Box Selected';
  static magazineSelected = () => 'Magazine Selected';
  static productsSearched = () => 'Products Searched';
  static productSelected = () => 'Product Selected';
  static productsSorted = () => 'Products Sorted';
  static productsPageChanges = () => 'Results Page Changed';
  static italistMarketplacePageSelected = () => 'Italist Marketplace Page Selected';
  static italistCustomerServicePageSelected = () => 'Customer Service Page Selected';
  static italistSocialShareSelected = () => 'Social Share Selected';
  static freshDeskStart = () => 'Freshchat Started';
  static productsViewed = () => 'Products Viewed';
  static productsDetailViewed = () => 'Product Details Viewed';
  static productImageExpanded = () => 'Product Image Expanded';
  static productImageZoomed = () => 'Product Image Zoomed';
  static productImageViewed = () => 'Product Image Viewed';
  static sizeListViewed = () => 'Size List Viewed';
  static sizeGuideViewed = () => 'Size Guide Viewed';
  static sizeGuideTabSelected = () => 'Size Guide Tab Selected';
  static productAdded = () => 'Product Added';
  static infoExpanded = () => 'Info Expanded';
  static infoCollapsed = () => 'Info Collapsed';
  static cartViewed = () => 'Cart Viewed';
  static checkoutStarted = () => 'Checkout Started';
  static productCountChanged = () => 'Product Count Changed';
  static productRemoved = () => 'Product Removed';
  static userSignsUp = () => 'User Signs Up';
  static userSignsIn = () => 'User Signs In';
  static userSignsOut = () => 'User Signs Out';
  static signupErrorViewed = () => 'Signup Error Viewed';
  static signinErrorViewed = () => 'Signin Error Viewed';
  static modalOpened = () => 'Modal Opened';
  static newsletterSubscribeSelected = () => 'Newsletter Subscribe Selected';
  static howToShopSelected = () => 'How to Shop Selected';
  static regionalLightboxViewed = () => 'Regional Lightbox Viewed';
  static newsletterSubscribeSubmitted = () => 'Newsletter Subscribe Submitted';
  static newsletterSubscribeViewed = () => 'Newsletter Subscribe Viewed';
  static productOutOfStock = () => 'Product Out of Stock';
  static productUnavailable = () => 'Product Unavailable';
  static productNoImages = () => 'Product No Images';
  static forgotPasswordSelected = () => 'Forgot Password Selected ';
  static emailSubmitted = () => 'Email Submitted';
  static passwordSubmitted = () => 'Password Submitted';
  static designersViewed = () => 'Designers Viewed';
  static myAccountClicked = () => 'My Account Clicked';
  static logoClicked = () => 'Logo Clicked';
  static breadcrumbClicked = () => 'Breadcrumb Clicked';
}
